import 'assets/css/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import store from "store";
import {ConfigProvider} from "antd";
import azAZ from 'antd/lib/locale/az_AZ';
import 'moment/locale/az'
import moment from "moment";
import GlobalProvider from "providers/GlobalProvider";

moment.locale('az')

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <ConfigProvider locale={azAZ}>
            <BrowserRouter>
                <GlobalProvider/>
            </BrowserRouter>
        </ConfigProvider>
    </Provider>
);
